import React from "react";
import "./brackets.css";
import logo from "../../../../assets/images/branding/logo-torneiofacil.png";
import { toast } from "react-toastify";

interface Fighter {
  gym: string;
  name: string;
}

interface Competitor {
  lutador: Fighter | "";
  posicao: number;
}

interface TournamentBracketProps {
  competitors: Competitor[][];
  tournamentRules: any[];
  category: string;
  tournamentName: string;
  tournamentLocation: string;
  tournamentDate: string;
  index: number;
  totalPages: number;
  is32Bracket?: boolean;
  isPartTwo?: boolean;
}

const TournamentBracket = ({
  competitors,
  tournamentRules,
  category,
  tournamentName,
  tournamentLocation,
  tournamentDate,
  index,
  totalPages,
  is32Bracket = false,
  isPartTwo = false,
}: TournamentBracketProps) => {
  const getCompetitorData = (position: number) => {
    for (const match of competitors) {
      if (match[0] && match[0].posicao === position) {
        const fighter = match[0].lutador;
        if (typeof fighter !== "string") {
          return (
            <>
              <span className="figther-name-a">{fighter.name}</span>
              <span className="figther-gym-a">
                {fighter.gym || "Sem academia"}
              </span>
            </>
          );
        }
      }
      if (match[1] && match[1].posicao === position) {
        const fighter = match[1].lutador;
        if (typeof fighter !== "string") {
          return (
            <>
              <span className="figther-name-a">{fighter.name}</span>
              <span className="figther-gym-a">
                {fighter.gym || "Sem academia"}
              </span>
            </>
          );
        }
      }
    }
    return "";
  };

  const normalize = (text: string) =>
    text?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "");

  const getDescriptionFromCategory = (categoryString: string) => {
    const cleanCategoryString = categoryString?.replace(/-parte\d+/gi, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

    const parts = cleanCategoryString.split("/");
    if (parts.length < 3) {
      console.log("Categorias não estão formatadas corretamente");
      return {
        ageDescription: "--",
        pesoDescription: "--",
        fightTime: "--",
      };
    }
    const category = normalize(parts[0]);
    const gender = normalize(parts[1]);
    const belt = normalize(parts[2]);
    const pesoDesc = normalize(parts[3]);


    const matchCategory = tournamentRules?.find((rule: any) => {
      const jsonGender = normalize(rule.genero);
      const jsonCategory = normalize(rule.categoria);
      const jsonBelts = rule.faixa.map((f: any) => normalize(f.nome));
      const jsonPesoDesc = normalize(rule.peso.descricao);

      return (
        jsonGender === gender &&
        jsonCategory === category &&
        jsonBelts.some((b: string) => b == belt) &&
        jsonPesoDesc === pesoDesc
      );
    });

    if (matchCategory) {

      const beltFightTime = matchCategory.faixa?.find(
        (b: { nome: string }) => normalize(b.nome) == belt
      );

      return {
        ageDescription: matchCategory.idade.descricaoCompleta,
        pesoDescription: matchCategory.peso.max,
        fightTime: beltFightTime ? beltFightTime.tempodeLuta : "--",
      };
    }

    console.log("Regas não encontradas para a categoria", categoryString);

    return {
      ageDescription: "--",
      pesoDescription: "--",
      fightTime: "--",
    };
  };

  const formatBrazilianDate = (dateString: string) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const renderLeftCompetitors = () => {
    let indicesInThisSide;

    if (is32Bracket) {
      if (isPartTwo) {
        // Indices for the left side of a 32-person bracket, part 2
        indicesInThisSide = [
          [2, 18],
          [10, 26],
          [6, 22],
          [14, 30],
        ];
      } else {
        // Indices for the left side of a 32-person bracket, part 1
        indicesInThisSide = [
          [1, 17],
          [9, 25],
          [5, 21],
          [13, 29],
        ];
      }
    } else {
      // Indices for a standard 16-person bracket
      indicesInThisSide = [
        [1, 9],
        [5, 13],
        [3, 11],
        [7, 15],
      ];
    }

    return indicesInThisSide.map((c: number[], i: number) => (
      <div className="match-container-a" key={i}>
        <div className="match-number-1-a">{c[0]}</div>
        <div className="match-number-2-a">{c[1]}</div>
        <div className="match-box-left-a">{getCompetitorData(c[0])}</div>
        <div className="match-box-left-a">{getCompetitorData(c[1])}</div>
        <div className="connector-line-a" />

        <div className="lines-container-a">
          <div className="line1TopLeft-a"></div>
          <div className="line1CenterLeft-a"></div>
          <div className="line1BottomLeft-a"></div>

          <div className="line2TopLeft-a"></div>
          {i % 2 === 0 && <div className="line2CenterLeft-a"></div>}

          {i === 0 && <div className="lineCenterLeft-a"></div>}
          {i === 0 && <div className="lineCenterRight-a"></div>}
          {i % 2 === 0 && <div className="lineTopRight-a"></div>}
          {i % 2 === 0 && <div className="lineTopLeft-a"></div>}

          <div className="line1TopRight-a"></div>
          <div className="line1CenterRight-a"></div>
          <div className="line1BottomRight-a"></div>

          <div className="line2TopRight-a"></div>
          {i % 2 === 0 && <div className="line2CenterRight-a"></div>}
          {i === 0 && <div className="lineCenterHorizontal-a"></div>}
          {i === 0 && <div className="lineCenterHorizontalTop-a"></div>}
        </div>
      </div>
    ));
  };

  const renderRightCompetitors = () => {
    let indicesInThisSide;

    if (is32Bracket) {
      if (isPartTwo) {
        // Indices for the right side of a 32-person bracket, part 2
        indicesInThisSide = [
          [4, 20],
          [12, 28],
          [8, 24],
          [16, 32],
        ];
      } else {
        // Indices for the right side of a 32-person bracket, part 1
        indicesInThisSide = [
          [3, 19],
          [11, 27],
          [7, 23],
          [15, 31],
        ];
      }
    } else {
      // Indices for a standard 16-person bracket
      indicesInThisSide = [
        [2, 10],
        [6, 14],
        [4, 12],
        [8, 16],
      ];
    }

    return indicesInThisSide.map((c: number[], i: number) => (
      <div className="match-container-a" key={i}>
        <div className="match-number-right-1-a">{c[0]}</div>
        <div className="match-number-right-2-a">{c[1]}</div>
        <div className="match-box-right-a">{getCompetitorData(c[0])}</div>
        <div className="match-box-right-a">{getCompetitorData(c[1])}</div>
        <div className="connector-line-a" />
      </div>
    ));
  };

  return (
    <div className="container-geral-bracket-a">
      <div className="header-bracket-a">
        <img src={logo} alt="" style={{ height: "30px" }} />

        <div className="lineHorizontalCategoryTop-a"></div>
        <h4>{tournamentName}</h4>
        <div className="lineHorizontalCategoryTop-a"></div>
        <h5>
          {category.replace("-Parte1", "").replace("-Parte2", "")},{" "}
          {getDescriptionFromCategory(category).ageDescription},{" "}
          {getDescriptionFromCategory(category).pesoDescription}, tempo de luta:{" "}
          {getDescriptionFromCategory(category).fightTime} min
        </h5>
        {is32Bracket && (
          <h5 style={{ margin: 0, padding: 0 }}>
            (Parte {isPartTwo ? "2" : "1"})
          </h5>
        )}
      </div>

      <div className="bracket-wrapper-a">
        <div className="bracket-column-a">{renderLeftCompetitors()}</div>

        <div className="bracket-center-a">
          <div className="bracket-line-vertical-a" />
          <div className="final-match-a">🏆 Final</div>
        </div>

        <div className="bracket-column-a">{renderRightCompetitors()}</div>
      </div>

      <div>
        <div className="lineHorizontalFooter-a"></div>
        <div className="footer-bracket-a">
          <h5>
            {tournamentLocation} , {formatBrazilianDate(tournamentDate)}
          </h5>
          <h5>
            www.torneiofacil.com.br {index + 1}/{totalPages}
          </h5>
        </div>
      </div>
    </div>
  );
};

export default TournamentBracket;
